import React from 'react';
import { useStore } from '@/context/StoreContext';
import { Globe } from 'lucide-react';

export const TopBanner = () => {
  const { t, lang, setLang, currency, setCurrency } = useStore();
  return (
    <div className="w-full bg-nw-espresso text-nw-warmgrey border-b border-nw-gold/15">
      <div className="nw-container h-9 flex items-center justify-between">
        <div className="flex items-center gap-2 text-[10px] sm:text-[11px] tracking-luxe uppercase min-w-0 flex-1 overflow-hidden">
          <Globe size={12} className="text-nw-gold hidden sm:block" />
          <span className="truncate block">{t.banner}</span>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 text-[10px] sm:text-[11px] tracking-wide2 uppercase shrink-0 pl-3">
          <div data-testid="top-banner-language-switcher" className="flex items-center gap-1">
            {['fr', 'en'].map((l) => (
              <button key={l} data-testid={`lang-${l}-button`} onClick={() => setLang(l)}
                className={`px-1 transition-colors ${lang === l ? 'text-nw-gold' : 'text-nw-warmgrey hover:text-nw-ivory'}`}>
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <span className="text-nw-gold/40">|</span>
          <div data-testid="top-banner-currency-switcher" className="flex items-center gap-1">
            {['EUR', 'USD', 'GBP'].map((c) => (
              <button key={c} data-testid={`currency-${c}-button`} onClick={() => setCurrency(c)}
                className={`px-1 transition-colors ${currency === c ? 'text-nw-gold' : 'text-nw-warmgrey hover:text-nw-ivory'}`}>
                {c}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
